export function isNullOrUndefined(val: Date | string | undefined | null): boolean {
	if (val === undefined || val === null) {
		return true;
	} else if (val.toString().trim() === '') {
		return true;
	} else {
		return false;
	}
}
